import { Caption } from '@heathmont/moon-core';

type Props = { file: File; position: number };

const FileInfo: FC<Props> = ({ file, position }) => (
  <Caption color="trunks.100" key={file?.name}>
    {position}. {file?.name} - {Math.ceil(file.size / 1000)} KB
  </Caption>
);

export default FileInfo;
